var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6763 10.5855C23.3884 10.1535 22.7884 10.0575 22.3804 10.3454C21.9485 10.6333 21.8285 11.2574 22.1403 11.6894C23.2444 13.2493 23.8203 15.2173 23.6283 17.3054C23.2684 21.2654 20.0763 24.4574 16.1163 24.8414C10.8843 25.3454 6.4683 21.0013 6.9243 15.7694C7.28423 11.5213 10.8603 8.20935 15.1083 8.11335V9.64935C15.1083 10.2013 15.7323 10.5373 16.1883 10.2493L20.1482 7.77735C20.6042 7.4894 20.6042 6.84135 20.1482 6.57735L16.1883 4.10535C15.7083 3.8174 15.1083 4.1534 15.1083 4.70535V6.24135C9.9723 6.31334 5.7003 10.1053 5.0763 15.2413C4.30821 21.6254 9.4443 27.0493 15.7563 26.7853C20.9883 26.5453 25.2843 22.2974 25.5483 17.0653C25.6683 14.6414 24.9483 12.4094 23.6763 10.5854L23.6763 10.5855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.39fe7c4dc44c9ce1690f1baa04c5c4eb.svg";
export { ForwardRef as ReactComponent };